/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { Table, Button } from 'antd'
import { changeStringTime, copyToClip } from '../../../util'

export default class extends React.Component {
  //导出报表
  clickDownload = (columns, list) => {
    let str = [],
      title = []
    columns.map((item) => {
      title.push(item.title)
    })
    str.push(title.join(','))
    for (let i = 0; i < list.length; i++) {
      let temp = []
      for (let j = 0; j < columns.length; j++) {
        temp.push(list[i][columns[j].dataIndex])
      }
      str.push(temp.join(','))
    }
    str = encodeURIComponent(str.join('\n'))
    return 'data:text/csv;charset=utf-8,\ufeff' + str
  }

  //求和(金额)
  priceSum = (list) => {
    let sum = 0
    list.map((item) => {
      sum += +item.amounts
    })
    return sum
  }

  render() {
    const { list, period } = this.props
    const columns = [
      {
        title: '操作人员',
        dataIndex: 'employee',
        key: 'employee',
        width: '25%',
      },
      {
        title: '录入目的',
        dataIndex: 'usage',
        key: 'usage',
        width: '25%',
      },
      {
        title: '录入时间',
        dataIndex: 'ctime',
        key: 'ctime',
        width: '25%',
      },
      {
        title: '金额[元]',
        dataIndex: 'amounts',
        key: 'amounts',
        width: '25%',
      },
    ]

    const data =
      list.list &&
      list.list.map((item) => {
        item.amounts = (+item.amount / 100).toFixed(2)
        return item
      })

    let reportName = sessionStorage.getItem('reportName')
    if (period && period.start_time && period.end_time) {
      reportName += `${changeStringTime(period.start_time)}-${changeStringTime(
        period.end_time
      )}`
    }

    const sum = this.priceSum(data)

    return (
      <div style={{ marginTop: '1rem' }}>
        <div
          style={{
            cursor: 'default',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: '1rem',
          }}
        >
          <Button>
            <a
              id="test"
              href={this.clickDownload(columns, data || [])}
              download={`${reportName}.csv`}
            >
              导出
            </a>
          </Button>
          <Button type="primary" ghost onClick={() => copyToClip(sum)}>
            合计:￥{sum}元
          </Button>
        </div>
        <h3>备用记录</h3>
        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={data}
          size="middle"
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStandby/component/report.js